import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { px2rem, theme } from '../../../theme/Global'

export const menuPositionProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
}
export const staticTypography = {
  marginLeft: '0.35rem',
  display: 'inline-block'
}
export const titleTypography = {
  padding: '1rem 0',
  display: 'inline-block'
}
export const InputAdornment = styled.span`
  color: ${theme.colors.text};
  padding: 0.7rem 0.3rem;
`
export const paddedBarWrapper = {
  marginTop: '2.5rem',
  borderTop: `1px solid ${theme.colors.divider}`,
  borderBottom: `1px solid ${theme.colors.divider}`
}
export const SettingsHeadingStyle = styled(Typography)`
  border-bottom: 1px solid ${theme.colors.divider};
  colors: ${theme.colors.text};
  padding-bottom: 2.25rem;
  font-size: ${px2rem(24)}rem;
`
